const wlConfig = {
    apiEndpoint: "https://api.wl-stg-logostore.com",
    configurationEndpoint: "https://api4internal.wl-stg-logostore.com",
    region:"us-east-1",
    userPoolId:"us-east-1_jjbZ99nbA",
    cognitoDomain:"wl-stg-logostore.auth.us-east-1.amazoncognito.com",
    scope:["email","profile","openid"],
    responseType:"code",
  };
  export default wlConfig;